import { render } from "./AcademyComponent.vue?vue&type=template&id=fc581c58"
import script from "./AcademyComponent.vue?vue&type=script&lang=js"
export * from "./AcademyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__